// extracted by mini-css-extract-plugin
export default {"fullscreen":"styles-module--fullscreen--f7eef","video":"styles-module--video--0983c","container":"styles-module--container--dad67"};